<template>
  <div class="page-card">
    <h2 class="page-title">消息中心</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-radio-group v-model="activeTab" size="small">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="system">系统通知</el-radio-button>
          <el-radio-button label="review">审核待办</el-radio-button>
          <el-radio-button label="ops">运营提醒</el-radio-button>
          <el-radio-button label="alert">异常告警</el-radio-button>
        </el-radio-group>
      </div>
      <div class="toolbar-left">
        <el-button @click="fetchData">刷新</el-button>
        <el-button type="primary" @click="markAllRead">全部已读</el-button>
        <el-button @click="goPrivateMessages">私信管理</el-button>
      </div>
    </div>

    <el-table :data="filteredList" border>
      <el-table-column label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.isRead ? 'info' : 'danger'">
            {{ row.isRead ? '已读' : '未读' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="分类" width="140">
        <template slot-scope="{ row }">
          {{ messageTypeLabel(row.messageType) }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="220" />
      <el-table-column prop="content" label="内容" min-width="320" show-overflow-tooltip />
      <el-table-column prop="createdAt" label="时间" width="180" />
      <el-table-column label="操作" width="220">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">查看</el-button>
          <el-button v-if="row.jumpPath" type="text" @click="jumpToTarget(row)">前往处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="filteredList.length === 0" class="empty-state">暂无消息</div>

    <el-dialog :visible.sync="detailVisible" title="消息详情" width="640px">
      <div v-if="currentMessage" class="detail-panel">
        <div class="detail-row">
          <span class="detail-label">分类</span>
          <span>{{ messageTypeLabel(currentMessage.messageType) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">时间</span>
          <span>{{ currentMessage.createdAt || '-' }}</span>
        </div>
        <div class="detail-row detail-block">
          <span class="detail-label">标题</span>
          <div>{{ currentMessage.title || '-' }}</div>
        </div>
        <div class="detail-row detail-block">
          <span class="detail-label">内容</span>
          <div class="detail-content">{{ currentMessage.content || '-' }}</div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <el-button v-if="currentMessage && currentMessage.jumpPath" type="primary" @click="jumpToTarget(currentMessage)">
          前往处理
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAdminMessageDetail,
  getAdminMessages,
  markAdminAllMessagesRead,
  markAdminMessageRead
} from '../../../api/opsMessage'

const TAB_MAP = {
  all: () => true,
  system: type => Number(type) === 1,
  review: type => Number(type) === 2,
  ops: type => Number(type) === 3,
  alert: type => Number(type) === 4
}

export default {
  name: 'OpsMessageCenterPage',
  data() {
    return {
      activeTab: 'all',
      list: [],
      detailVisible: false,
      currentMessage: null
    }
  },
  computed: {
    filteredList() {
      const matcher = TAB_MAP[this.activeTab] || TAB_MAP.all
      return this.list.filter(item => matcher(item.messageType))
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    messageTypeLabel(type) {
      const map = {
        1: '系统通知',
        2: '审核待办提醒',
        3: '运营提醒',
        4: '异常告警'
      }
      return map[Number(type)] || '后台消息'
    },
    async fetchData() {
      const data = await getAdminMessages().catch(() => [])
      this.list = Array.isArray(data) ? data : []
    },
    async markAllRead() {
      await markAdminAllMessagesRead()
      this.$message.success('已全部标记为已读')
      this.list = this.list.map(item => ({
        ...item,
        isRead: 1
      }))
    },
    async openDetail(row) {
      const detail = await getAdminMessageDetail(row.id).catch(() => null)
      if (!detail) {
        return
      }
      this.currentMessage = detail
      this.detailVisible = true
      if (!detail.isRead) {
        await markAdminMessageRead(detail.id).catch(() => null)
        this.currentMessage.isRead = 1
        this.list = this.list.map(item => (
          item.id === detail.id
            ? {
                ...item,
                isRead: 1
              }
            : item
        ))
      }
    },
    jumpToTarget(row) {
      if (!row || !row.jumpPath) {
        return
      }
      this.detailVisible = false
      this.$router.push(row.jumpPath)
    },
    goPrivateMessages() {
      this.$router.push('/platform/private-messages')
    }
  }
}
</script>

<style scoped>
.empty-state {
  padding: 24px 0 4px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}

.detail-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-row {
  display: flex;
  gap: 12px;
  font-size: 14px;
  color: #303133;
}

.detail-block {
  align-items: flex-start;
}

.detail-label {
  width: 72px;
  color: #909399;
  flex-shrink: 0;
}

.detail-content {
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
